export default __webpack_public_path__ + "static/media/updating.7c41b220.svg";